import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/userService';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-reset-token',
  templateUrl: './reset-token.component.html',
  styleUrls: ['./reset-token.component.css']
})

export class ResetTokenComponent implements OnInit {

    constructor(
        private userService: UserService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private formBuilder: FormBuilder) { }

    userId: string
    token: string
    resetForm: FormGroup;
    Message: string;
    Error : boolean = false;
    ngOnInit() {
        this.activatedRoute.queryParams.subscribe( params => {
            this.userId = params['userid'];
            this.token = params['token'];
            console.log(params);
            this.buildForm();
        })
    }

    buildForm() {
        this.resetForm = this.formBuilder.group({
            password: ['', [Validators.required, Validators.pattern(new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[#$^+=!*()@%&]).{8,}$'))]],
            confirmPassword: ['', [Validators.required, Validators.pattern(new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[#$^+=!*()@%&]).{8,}$'))]],
        });
    }

    isMatch(): boolean {

        return this.resetForm.controls['password'].value == this.resetForm.controls['confirmPassword'].value;
    }

    IsValid(): boolean {
        return !this.resetForm.invalid && this.isMatch();
    }

    changePassword(formData) {
        var pw = this.resetForm.controls['password'].value;
        this.userService.resetWithToken(this.userId, this.token, pw).subscribe(data => {
            console.log(data);
            if (data == 'true') {
                this.router.navigate(['login']);
            }
            else {
              this.Message = "Your token has expired; Please reset password again";
            }
        });
    }
}
